import request from '@/utils/request'

// 根据支付订单号查询
export function fetchPayOrderList(data) {
  return request({
    url: `/merchant-api/customServiceOrder/getPaymentList`,
    method: 'post',
    data
  })
}

// 根据代付订单号查询
export function fetchPoOrderList(data) {
  return request({
    url: `/merchant-api/customServiceOrder/getDisbursementList`,
    method: 'post',
    data
  })
}

// 提交退款说明
export function submitRefundInstruction(params) {
  return request({
    url: '/institute/feePlan/templates',
    method: 'post',
    data: params
  })
}

export function fetchPayDetail(params) {
  return request({
    url: `/merchant-api/transaction/getPaymentDetail`,
    method: 'get',
    params
  })
}

// 获取代付详情列表
export function fetchPayoutDetail(params) {
  return request({
    url: `/merchant-api/transaction/getDisbursementDetail`,
    method: 'get',
    params
  })
}

// 客服工单列表start
// 获取客服工单列表
export function fetchTicketList(data) {
  return request({
    url: '/merchant-api/mch/issue/issueList',
    method: 'post',
    data
  })
}

// 获取客服工单列表 ----下载
export function fetchDownloadTicketList(data) {
  return request({
    url: '/merchant-api/mch/issue/export',
    method: 'post',
    data
  })
}

// 提交添加工单
export function addTicket(data) {
  return request({
    url: '/merchant-api/mch/issue/save',
    method: 'post',
    data
  })
}
export function ticketDetail(params) {
  return request({
    url: `/merchant-api/mch/issue/detail/${params.id}`,
    method: 'get',
    params
  })
}

export function reOpenTicket(data) {
  return request({
    url: '/merchant-api/mch/issue/reOpen',
    method: 'post',
    data
  })
}
// 客服工单列表end

export function disburseNotice(params) {
  return request({
    url: `/merchant-api/customServiceOrder/retryDirbursementNotice`,
    method: 'get',
    params
  })
}

export function paymentNotice(params) {
  return request({
    url: `/merchant-api/customServiceOrder/retryPaymentNotice`,
    method: 'get',
    params
  })
}
export function uploadFile(data) {
  return request({
    url: '/mch/issue/uploadFile',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}

export function refundDetail(params) {
  return request({
    url: '/merchant-api/payment/refund/refund/detail',
    method: 'post',
    data: params
  })
}

export function refundDownload(params) {
  return request({
    url: '/merchant-api/payment/refund/download',
    method: 'post',
    data: params
  })
}

export function refundCancel(params) {
  return request({
    url: '/merchant-api/payment/refund/payment/refund/cancel',
    method: 'post',
    data: params
  })
}

export function paymentRefund(data) {
  return request({
    url: '/merchant-api/payment/refund',
    method: 'post',
    data
  })
}
export function refundCustomerSearch(data) {
  return request({
    url: '/merchant-api/payment/refund/customer/search',
    method: 'post',
    data
  })
}

// 多币种客服支付交易列表
export function fetchMultiMchPayOrderList(data = {}) {
  return request({
    url: '/merchant-api/customServiceOrder/getMultiMchPaymentList',
    method: 'post',
    data
  })
}

// 多币种客服代付交易列表
export function fetchMultiMchPoOrderList(data = {}) {
  return request({
    url: '/merchant-api/customServiceOrder/getMultiMchDisbursementList',
    method: 'post',
    data
  })
}
